import { Link } from 'react-router'
import { Analytics } from 'common-frontend'
import connectToStores from 'alt-utils/lib/connectToStores'

import { Button } from 'components'
import { CheckStore } from 'stores'
import { Toolbar, ToolbarGroup } from 'material-ui/Toolbar'
import FontIcon from 'material-ui/FontIcon'
import FlatButton from 'material-ui/FlatButton'
import IconButton from 'material-ui/IconButton'
import MenuItem from 'material-ui/MenuItem'
import { Tab } from 'material-ui/Tabs'
import Drawer from 'material-ui/Drawer'
import { API_BASE, SEO_SERVICES_PATH, UI_MIGRATION_PATH } from 'consts'

import './header.scss'

@connectToStores
export default class Header extends React.Component {
  static contextTypes = {
    authenticated: React.PropTypes.bool.isRequired,
    currentUser: React.PropTypes.object,
    muiTheme: React.PropTypes.object.isRequired,
    history: React.PropTypes.object.isRequired,
    location: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired,
  }

  static propTypes = {
    checks: React.PropTypes.object,
  }

  static getStores() {
    return [CheckStore]
  }

  static getPropsFromStores() {
    return {
      ...CheckStore.getState(),
    }
  }

  constructor(props) {
    super(props)

    this.state = {
      selectedTabIndex: -1,
      showDrawer: false,
    }

    this.showDrawer = this.showDrawer.bind(this)
    this.navigateFromDrawer = this.navigateFromDrawer.bind(this)
    this.onTapPromotion = this.onTapPromotion.bind(this)
    this.onDrawerCloseRequest = this.onDrawerCloseRequest.bind(this)
  }

  componentWillMount() {
    const { currentUser } = this.context

    this.activateCurrentTab()
  }

  componentWillReceiveProps() {
    this.activateCurrentTab()
  }

  showDrawer(truthy) {
    if (truthy) {
      Analytics.track('Side Menu Opened', {
        email: this.context.currentUser.email,
      })
    }

    this.setState({
      showDrawer: truthy,
    })
  }

  navigateFromDrawer(path) {
    this.showDrawer(false)
    this.context.history.push(path)
  }

  onDrawerCloseRequest(reason) {
    if (reason === 'clickaway') this.showDrawer(false)
  }

  onTapPromotion(appName) {
    Analytics.track('App Promotion Clicked', {
      email: this.context.currentUser.email,
      app_name: appName,
    })
  }

  activateCurrentTab() {
    const path = location.pathname
    if (path.startsWith('/admin')) this.setState({ selectedTabIndex: 3 })
    else if (path.startsWith('/plus')) this.setState({ selectedTabIndex: 2 })
    else if (path.startsWith('/get-it-fixed'))
      this.setState({ selectedTabIndex: 1 })
    else if (path.startsWith('/checks')) this.setState({ selectedTabIndex: 0 })
  }

  navigateToGetItFixed() {
    window.location.href = API_BASE + SEO_SERVICES_PATH;
  }

  navigateToMigrateUI() {
    Analytics.track('Clicked Try New UI', null, null, function() {
      window.location.href = API_BASE + UI_MIGRATION_PATH;
    })
  }

  renderAuth() {
    let actions = null
    let palette = this.context.muiTheme.palette

    if (this.context.authenticated) {
      let anonymous = this.context.currentUser.anonymous

      if (anonymous) {
        actions = (
          <FlatButton
            key="anonsignup"
            label="Sign Up"
            style={{ color: palette.alternateTextColor }}
            onTouchTap={() => {
              this.context.router.push('/users/sign_up')
            }}
          />
        )
      } else if (this.context.currentUser.provider !== 'shopify') {
        actions = (
          <FlatButton
            key="signout"
            label="Sign Out"
            style={{ color: palette.alternateTextColor }}
            onTouchTap={() => {
              this.context.router.push('/users/sign_out')
            }}
          />
        )
      }
    } else {
      actions = [
        <FlatButton
          key="signin"
          label="Sign In"
          style={{ color: palette.alternateTextColor }}
          onTouchTap={() => {
            this.context.router.push('/users/sign_in')
          }}
        />,
        <FlatButton
          key="signup"
          label="Sign Up"
          style={{ color: palette.alternateTextColor }}
          onTouchTap={() => {
            this.context.router.push('/users/sign_up')
          }}
        />,
      ]
    }

    return actions
  }

  render() {
    let currentUser = this.context.currentUser
    let palette = this.context.muiTheme.palette
    let plusButton = null
    let adminTab = null

    if (this.context.authenticated) {
      if (!currentUser.activeCharge) {
        plusButton = (
          <Button
            id=""
            label="Upgrade to plus"
            buttonType="primary"
            className="topnav__plus-btn"
            onTouchTap={() => window.location.replace(`${API_BASE}/v3ui/pricing`)}
          />
        )
      }

      if (currentUser.admin === true) {
        adminTab = (
          <Tab
            value={3}
            style={{
              height: '54px',
              backgroundColor: palette.primary,
              fontFamily: 'Montserrat,sans-serif',
              fontWeight: '400',
            }}
            label="Admin"
            onActive={() => this.context.router.push('/admin')}
          />
        )
      }
    }

    return this.renderToolbarGroup(adminTab, plusButton, this.renderAuth())
  }

  renderMenuItem(title, link, isPlusFeature = false) {
    const { currentUser, muiTheme, location } = this.context
    const isLocked = !currentUser.activeCharge && isPlusFeature
    const isCurrentPath = location.pathname === link

    let textElement
    if (isLocked) {
      textElement = (
        <div className="topnavburger__option">
          <FontIcon
            className="material-icons"
            style={{
              fontSize: 16,
              color: muiTheme.palette.blue,
              marginLeft: -2,
            }}
          >
            lock
          </FontIcon>
          <div className="option-title">
            <h4>{title}</h4>
          </div>
          <div className="plus-only">plus</div>
        </div>
      )
    } else {
      textElement = (
        <span
          className={`topnavburger__option ${isCurrentPath ? 'active' : ''}`}
        >
          {title}
        </span>
      )
    }

    return (
      <MenuItem
        key={`menu-item-${link}`}
        className={`topnavburger__menuItem ${isLocked ? 'locked' : ''}`}
        primaryText={textElement}
        onTouchTap={() => !isLocked && this.navigateFromDrawer(link)}
      />
    )
  }

  renderMenuItemAnchor(title, link, flag = null) {
    const { currentUser, muiTheme, location } = this.context
    const isLocked = false
    const isCurrentPath = location.pathname === link

    let textElement
    if (flag) {
      textElement = (
        <a href={`${API_BASE}${link}`}
          className={`topnavburger__option ${isCurrentPath ? 'active' : ''}`}
          style={{ textDecoration: 'none' }}
        >
          {title}
          <span className="plus-only">{flag}</span>
        </a>
      )
    } else {
      textElement = (
        <a href={`${API_BASE}${link}`}
          className={`topnavburger__option ${isCurrentPath ? 'active' : ''}`}
          style={{ textDecoration: 'none' }}
        >
          {title}
        </a>
        
      )
    }

    return (
      <MenuItem
        key={`menu-item-${link}`}
        className={`topnavburger__menuItem ${isLocked ? 'locked' : ''}`}
        primaryText={textElement}
        onTouchTap={() => document.location = API_BASE + link }
      />
    )
  }

  renderToolbarGroup(adminTab, plusButton, auth) {
    const palette = this.context.muiTheme.palette
    const blogCheck = this.props.checks.find(
      check => check.get('name') === 'Blog',
    )
    const isBlogSetup = blogCheck && blogCheck.get('enabled')
    const urlParams = new URLSearchParams(window.location.search);
    const newUI = this.context.authenticated && this.context.currentUser.canSeeUiToggle;

    return (
      <Toolbar style={{ backgroundColor: palette.primary, height: '60px' }}>
        <ToolbarGroup key={0} style={{ maxHeight: '100%' }}>
          {this.context.authenticated && (
            <div className="topnavburger">
              <IconButton
                iconClassName="material-icons foreground-white"
                style={{ marginLeft: '-20px' }}
                onClick={() => this.showDrawer(true)}
              >
                menu
              </IconButton>
              <Drawer
                className="topnavburger__drawer"
                open={this.state.showDrawer}
                docked={false}
                onRequestChange={(open, reason) =>
                  !open && this.onDrawerCloseRequest(reason)
                }
                width="340"
              >
                <Toolbar
                  style={{
                    backgroundColor: palette.primary,
                    height: '60px',
                    paddingRight: 12,
                  }}
                >
                  <ToolbarGroup
                    style={{ width: '100%', justifyContent: 'flex-end' }}
                  >
                    <IconButton
                      iconClassName="material-icons foreground-white"
                      onClick={() => this.showDrawer(false)}
                    >
                      clear
                    </IconButton>
                  </ToolbarGroup>
                </Toolbar>
                <div className="topnavburger__content">
                  <div className="topnavburger__option-container">
                    {this.renderMenuItem('My Dashboard', '/checks')}
                    {this.renderMenuItem(
                      'SEO Problems Check',
                      '/checks/seoproblems',
                    )}
                    {this.renderMenuItem(
                      'Blog Check',
                      isBlogSetup ? '/checks/blog' : '/checks/setup/blog',
                    )}
                    {this.renderMenuItem(
                      'Broken Links Check',
                      '/checks/notfound',
                      true,
                    )}
                    {this.renderMenuItem('Search Trends', '/plus/trends', true)}
                    {this.renderMenuItem(
                      'Titles and Descriptions',
                      '/plus/title-description',
                      true,
                    )}
                    {this.renderMenuItem(
                      'JSON-LD Structured Data',
                      '/plus/structured-data',
                      true,
                    )}
                    {this.renderMenuItemAnchor(
                      'SEO Report (Beta)',
                      '/v2ui/seo_report',
                      'PRO'
                    )}
                    {this.renderMenuItemAnchor(
                      'Speed Report',
                      '/v2ui/speed_report',
                      'PRO'
                    )}
                    {!this.context.currentUser.activeCharge && (
                      <Button
                        className="topnavburger__option-container__plusBtn"
                        label="Upgrade to plus"
                        buttonType="primary"
                        onTouchTap={() =>
                          this.navigateFromDrawer('/plus/upgrade')
                        }
                      />
                    )}
                    {this.renderMenuItemAnchor(
                      'Plan Settings',
                      '/v3ui/pricing',
                    )}
                    {this.renderMenuItemAnchor(
                      'PISEO Services',
                      SEO_SERVICES_PATH,
                    )}
                  </div>
                  <h5 className="topnavburger__app-header">
                    Discover More Apps
                  </h5>
                  <MenuItem
                    className="topnavburger__menuItem"
                    primaryText={
                      <span>
                        <img
                          className="topnavburger__app-logo"
                          alt="Plug in Speed"
                          src="/assets/images/speed-logo.png"
                        />
                        <span className="topnavburger__app-name">
                          Plug in Speed
                        </span>
                      </span>
                    }
                    href="https://api.pluginspeed.com/?ref=seo-navigation&utm_source=seo-navigation&utm_medium=plug_in_seo&utm_campaign=cross_app_promotion"
                    target="_blank"
                    onTouchTap={() => this.onTapPromotion('pluginspeed')}
                  />
                </div>
              </Drawer>
            </div>
          )}
          <Link to="/">
            <img
              className="logo"
              alt="Plug in SEO"
              src="/assets/images/logo.png"
            />
          </Link>
        </ToolbarGroup>
        <ToolbarGroup key={1} style={{ float: 'right' }}>
          {newUI &&
            <Button
              id=""
              label="Try New UI"
              buttonType="primaryLight"
              className="topnav__getitfixed-btn"
              onTouchTap={() => this.navigateToMigrateUI()}
            />
          }
          {plusButton}
          {auth}
        </ToolbarGroup>
      </Toolbar>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/header/Header.js